import React, { useContext } from 'react';
import PartnerOverviewComponent from '../../components/PartnerOverviewComponent';
import { Panel } from '../../components/Panel';
import IconComponent from '../../components/IconComponent';
import { AppContext } from "../../context/AppContext";

/**
 * PartnerOverview
 * @constructor
 */
export function PartnerOverview() {
  const {
    getRoutes
  } = useContext(AppContext);

  /**
   * ROUTE_CONFIG
   */
  const ROUTE_CONFIG = getRoutes();

  /**
   * render
   */
  return (
        <>
          <Panel
            header={
              <>
                <IconComponent iconName={ ROUTE_CONFIG.PARTNER_OVERVIEW.icon } />
                { ROUTE_CONFIG.PARTNER_OVERVIEW.title }
              </>
            }
          >
            <PartnerOverviewComponent />
          </Panel>
        </>
  );
}
